var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 511.987 511.987",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 183.48,
    cy: 44.57,
    r: 44.57,
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m252.461 217.965-67.615-17.56-25.066-72.603 38.113 55.961 5.94-43.385c2.256-16.477-9.272-31.662-25.748-33.918l-53.202-7.284c-16.477-2.256-31.662 9.272-33.918 25.748l-19.89 145.265a66.198 66.198 0 0 0-.276 15.632l9.294 91.917-43.72 100.327c-5.347 12.269.264 26.55 12.535 31.898 12.28 5.351 26.556-.276 31.898-12.535l46.278-106.194a24.205 24.205 0 0 0 1.883-12.232l-9.978-94.308 14.481 1.983 15.023 87.044 5.661 115.219c.658 13.394 12.065 23.684 25.394 23.016 13.368-.657 23.673-12.026 23.016-25.394l-5.734-116.694a24.269 24.269 0 0 0-.324-2.933l-13.211-76.55 3.785-27.64-27.74-7.204c-18.057-4.69-27.481-20.498-28.428-29.751l-8.391-82.144L150.2 223.82a20.195 20.195 0 0 0 14.014 12.956l78.1 20.282c10.861 2.82 21.845-3.791 24.618-14.472 2.804-10.796-3.678-21.819-14.471-24.621z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 338.539,
    cy: 44.57,
    r: 44.57,
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m469.08 171.366-69.322-48.869 32.765 13.217-1.478-10.79c-2.256-16.477-17.441-28.005-33.918-25.748l-53.202 7.284c-16.477 2.256-28.005 17.441-25.748 33.918l8.588 62.727c-38.167 9.913-32.568 8.458-46.677 12.122 6.562 9.66 8.462 21.242 5.608 32.232a39.505 39.505 0 0 1-3.553 8.964l50.139-13.022 6.851 50.039.211-.029-12.688 73.522a24.269 24.269 0 0 0-.324 2.933l-5.734 116.694c-.678 13.791 10.303 25.423 24.226 25.423 12.837 0 23.548-10.082 24.185-23.045l5.662-115.219 15.049-87.206 11.887-1.628-9.714 91.813a24.223 24.223 0 0 0 .173 6.404L409.544 491.6c2.131 13.225 14.578 22.2 27.781 20.072 13.214-2.129 22.201-14.566 20.072-27.781l-16.965-105.307 7.527-71.15c-18.807-3.5-32.848-20.287-32.306-40l1.72-62.435-43.192-51.117 62.776 44.255-1.924 69.83c-.283 10.276 7.161 18.973 17.065 20.511 11.956 1.855 22.973-7.18 23.31-19.398l2.224-80.652a20.268 20.268 0 0 0-8.552-17.062z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.8e8a8616e883ea7934a47cf70fe6b397.svg";
export { ForwardRef as ReactComponent };